export default "/assets/images/vendor/leaflet-extra-markers/dist/markers_shadow@2x.png?dfc8c849388499bd892c9e2b06e810d2";